import { useMemo } from 'react';
import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';

import useTwilioMessages from './useTwilioMessages';
import useLastReadMessageIndex from './useLastReadMessageIndex';

export default function useUnreadMessageCount() {
  const { data: helpCenter } = useFetchHelpCenter();
  const { data: twilioData } = useTwilioMessages(Boolean(helpCenter?.twilio_credentials));
  const { lastReadMessageIndex } = useLastReadMessageIndex();

  const unreadCount = useMemo(() => {
    let count = 0;
    let foundLast = false;

    if (!twilioData) return count;

    for (const message of twilioData.messages) {
      if (foundLast) {
        count++;
      }
      if (message.index === lastReadMessageIndex) {
        foundLast = true;
      }
    }

    return count;
  }, [twilioData, lastReadMessageIndex]);

  return unreadCount;
}
